import React, { useState, useEffect } from 'react'
import DropFile from '../../../../../../../Components/Common/DropFıle'
import { useDispatch, useSelector } from 'react-redux';
import { connectFeed, highlightDynamicTexts, removeHighlightDynamicTexts, setCreativesDynamicText, setDynamicTextTag, updatePreviewWhenImageToggled } from '../../../../../../../slices/campaigns/thunk';
import { getHeightAndWidthFromDataUrl, getPreviewAndSizeFromFile } from '../../../../../../../slices/helper.js';
import { createSelector } from 'reselect';
import { setSelectPathModalKind, toggleFeedConnectionLoader, toggleFeedConnectionModal, toggleSelectPathModal, toggleTargetUrlModal } from '../../../../../../../slices/modals/reducer.js';
import { setActiveDynamicText, setCreatives, setDynamicText, setFilteredCreatives, setSelectedTag } from '../../../../../../../slices/campaigns/reducer.js';
import { setFeedsFirstLoad, setFeedsHasMore, setFeedsLoading, setFeedsPage, setFeedsShowLoader, setSelectedPath } from '../../../../../../../slices/feeds/reducer.js';
import { getFeeds } from '../../../../../../../slices/feeds/thunk.js';
import ComponentShowerHook from '../../../../../../../Components/Hooks/ComponentShowerHook.js';
// import { setDynamicTextTag } from '../../../../../../../slices/campaigns/reducer';
import { cleanString } from '../../../../../../../slices/helper.js';
function DynamicImage({ item, idx, scrollableNodeRef }) {
  const dispatch = useDispatch();
  const stateSelect = createSelector(state => state, state => ({
    currentVersion: state.Campaign.currentVersion,
    dynamicText: state.Campaign.dynamicText,
    activeDynamicText: state.Campaign.activeDynamicText,
    connectedFeed: state.Campaign.connectedFeed,
    creatives: state.Campaign.creatives,
    scrolledCreatives: state.Campaign.scrolledCreatives,
    selectedCreative: state.Campaign.selectedCreative,
  }));
  const {
    currentVersion,
    dynamicText,
    activeDynamicText,
    connectedFeed,
    creatives,
    scrolledCreatives,
    selectedCreative
  } = useSelector(stateSelect);
  const [isComponentVisible, setIsComponentVisible] = useState(false);
  const [defaultImage, setDefaultImage] = useState(false);
  const [imageType, setImageType] = useState('');
  const [pixelSize, setPixelSize] = useState("");
  const [isVisible, setIsVisible] = useState(true);
  const loadImage = async file => new Promise((resolve, reject) => {
    if (file[0].type.includes("image")) {
      const reader = new FileReader();
      reader.readAsDataURL(file[0]);
      reader.onload = async () => {
        let encoded = reader.result;
        if (activeDynamicText.isCreative) {
          const updatedDynamicText = await dispatch(setDynamicTextTag({ ...item, value: encoded, file: file[0] }));
          dispatch(setActiveDynamicText(updatedDynamicText));
        } else {
          const newTexts = [];
          dynamicText[0].texts.forEach(dItem => {
            if (dItem.tag === item.tag) {
              newTexts.push({ ...dItem, value: encoded, file: file[0] });
            } else {
              newTexts.push(dItem);
            }
          });
          const newDynamicTextObj = { ...dynamicText[0], texts: newTexts, isCreative: true, creativeId: selectedCreative?._id };
          delete newDynamicTextObj._id;
          delete newDynamicTextObj.id;
          dispatch(setDynamicText([...dynamicText, newDynamicTextObj]));
          dispatch(setActiveDynamicText(newDynamicTextObj));
        }
        dispatch(setCreativesDynamicText());
        setPixelSize(await getHeightAndWidthFromDataUrl(encoded))
        setImageType(encoded.split(',')[0].replace('data:', '').split('/')[1].replace(';base64', ''));
        setDefaultImage(encoded);
        resolve(encoded);
      };
    }
  });

  useEffect(() => {
    if (selectedCreative) {
        getTemplateImage(selectedCreative)
    } else {
      // getTemplateImage(creatives[0])
    }
  }, [activeDynamicText]);

  useEffect(() => {
    async function getImagePixelSize(imageUrl) {
      const size = await getHeightAndWidthFromDataUrl(imageUrl.replace(/^url\(["']?(.*?)["']?\)$/, '$1'))
      setPixelSize(size);
    }
    if (item?.value) {
      if (item.isFeed) {
        const foundFeed = connectedFeed.find(feed => feed.path === item.value && feed.name === item.feedName);
        getImagePixelSize((foundFeed?.values[0] ? foundFeed?.values[0] : ''));
        setDefaultImage((foundFeed?.values[0] ? foundFeed?.values[0] : ''));
      } else {
        getImagePixelSize(item.value);
        setDefaultImage(item.value.replace(/^url\(["']?(.*?)["']?\)$/, '$1'));
      }
    } else {
      // setPixelSize("");
    }
  }, [item])


  useEffect(() => {
    toggleBackground(false);
  }, [item]);

  // useEffect(() => {
  //   dispatch(setDynamicTextTag({...item, backgroundStatus: isVisible}));
  // }, [isVisible]);

  function getTemplateImage(creative) {
    if (item?.isFeed === true) {
      const foundFeed = connectedFeed.find(feed => feed.path === item.value && feed.name === item.feedName);
      setDefaultImage((foundFeed.values[0] ? foundFeed.values[0] : ''));
      setPixelSize('');
      setImageType(''); 
    }
    else if (creative.figmaObject && creative.figmaObject.node) {
      const elIds = Object.keys(creative.figmaObject.node);
      let i = 0;
      do {
        if (creative.figmaObject.node[elIds[i]].hasOwnProperty("name")) {
          if (cleanString(creative.figmaObject.node[elIds[i]].name) === cleanString(item.name) && creative.figmaObject.node[elIds[i]].hasOwnProperty('bgimages')) {
            setDefaultImage(creative.figmaObject.node[elIds[i]].bgimages["1x"].data);
            setPixelSize(Math.floor(Number(creative.figmaObject.node[elIds[i]].bgimages["1x"].size.width)) + 'x' + Math.floor(Number(creative.figmaObject.node[elIds[i]].bgimages["1x"].size.height)));
            setImageType(creative.figmaObject.node[elIds[i]].bgimages["1x"].data.split(',')[0].replace('data:', '').split('/')[1].replace(';base64', ''));
            break;
          }
        }
        i++;
      } while (i < elIds.length);  
    }
    
  }

  function highlightImage() {
    setIsComponentVisible(true);
    dispatch(highlightDynamicTexts(item.tag));
  };

  function removeHighlight() {
    setIsComponentVisible(false);
    dispatch(removeHighlightDynamicTexts());
  }

  async function toggleBackground(isSet) {
    const updateCreatives = [];
    let i = 0;
    do {
      let creative = { ...creatives[i] };
      if (activeDynamicText.isCreative) {
        if (creative._id === activeDynamicText.creativeId && creative.figmaObject) {
          const nodeObj = setCreativeNodeBackground(creative, isSet);
          updateCreatives.push({ ...creative, figmaObject: { ...creative.figmaObject, animation: creative.figmaObject.animation, node: nodeObj } });
          if (isSet) {
            const imagePath = getImagePathFromCreativeObj(nodeObj);
            dispatch(updatePreviewWhenImageToggled({ creativeId: creative._id, isVisible: isVisible, tag: item.tag }));
            let obj = { ...item, backgroundStatus: !isVisible }
            if (obj.backgroundStatus === true && (!obj.value || obj.value.trim() === '')) {
              obj.value = imagePath;
            }
            await dispatch(setDynamicTextTag(obj));
          }
        } else {
          updateCreatives.push(creative);
        }
      } else if (activeDynamicText.isCreative === false) {
        if (!dynamicText.find(dText => dText.isCreative && dText.creativeId === creative._id) && selectedCreative._id === creative._id && creative.figmaObject) {
          const nodeObj = setCreativeNodeBackground(creative, isSet);
          updateCreatives.push({ ...creative, figmaObject: { ...creative.figmaObject, animation: creative.figmaObject.animation, node: nodeObj } });
          if (isSet) {
            const imagePath = getImagePathFromCreativeObj(nodeObj);
            dispatch(updatePreviewWhenImageToggled({ creativeId: creative._id, isVisible: isVisible, tag: item.tag }));
            const newTexts = [];
            dynamicText[0].texts.forEach(dItem => {
              if (dItem.tag === item.tag) {
                let obj = { ...item, backgroundStatus: !isVisible };
                if (obj.backgroundStatus === true && (!obj.value || obj.value.trim() === '')) {
                  obj.value = imagePath;
                }
                newTexts.push(obj);
              } else {
                newTexts.push(dItem);
              }
            });
            const newDynamicTextObj = { ...dynamicText[0], texts: newTexts, isCreative: true, creativeId: selectedCreative?._id };
            delete newDynamicTextObj._id;
            delete newDynamicTextObj.id;
            dispatch(setDynamicText([...dynamicText, newDynamicTextObj]));
            // dispatch(setActiveDynamicText(null));
            // setTimeout(() => {
            dispatch(setActiveDynamicText(newDynamicTextObj));
            // }, 1);
          }
        } else {
          updateCreatives.push(creative)
        }
      }
      i++;
    } while (i < creatives.length);
    dispatch(setCreatives(updateCreatives));
    dispatch(setFilteredCreatives(updateCreatives));
  }

  function setCreativeNodeBackground(creative, isSet) {
    let nodeObject = {};
    const node = Object.keys(creative.figmaObject.node);
    let k = 0;
    do {
      if (creative.figmaObject.node[node[k]].name) {
        if (cleanString(creative.figmaObject.node[node[k]].name) === item.name) {
          if (creative.figmaObject.node[node[k]].css['background-status'] && creative.figmaObject.node[node[k]].css['background-status'] === 'hidden') {
            const nodeKeys = Object.keys(creative.figmaObject.node[node[k]]);
            nodeObject[node[k]] = {};
            nodeKeys.forEach(item => {
              if (item !== 'css') {
                nodeObject[node[k]][item] = {};
                nodeObject[node[k]][item] = creative.figmaObject.node[node[k]][item];
              }
            });
            nodeObject[node[k]].css = setCreativeNodeCss(creative.figmaObject.node[node[k]].css, isSet);
          } else {
            const nodeKeys = Object.keys(creative.figmaObject.node[node[k]]);
            nodeObject[node[k]] = {};
            nodeKeys.forEach(item => {
              if (item !== 'css') {
                nodeObject[node[k]][item] = {};
                nodeObject[node[k]][item] = creative.figmaObject.node[node[k]][item];
              }
            });
            nodeObject[node[k]].css = setCreativeNodeCss(creative.figmaObject.node[node[k]].css, isSet);
          }
        } else {
          nodeObject[node[k]] = creative.figmaObject.node[node[k]];
        }
      } else {
        nodeObject[node[k]] = creative.figmaObject.node[node[k]];
      }

      k++;
    } while (k < node.length);
    return nodeObject;
  }

  function setCreativeNodeCss(css, isSet) {
    const cssObj = {};
    const cssKeys = Object.keys(css);
    let i = 0;
    do {
      if (cssKeys[i] === 'background-status') {
        if (css[cssKeys[i]] === 'hidden') {
          if (isSet) {
            cssObj[cssKeys[i]] = 'show';
            setIsVisible(true);
          } else {
            cssObj[cssKeys[i]] = 'hidden';
            setIsVisible(false)
          }
        } else {
          if (isSet) {
            cssObj[cssKeys[i]] = 'hidden';
            setIsVisible(false);
          } else {
            cssObj[cssKeys[i]] = 'show';
            setIsVisible(true);
          }
        }
      } else {
        cssObj[cssKeys[i]] = css[cssKeys[i]];
      }
      i++;
    } while (i < cssKeys.length);
    if (!cssObj.hasOwnProperty('background-status')) {
      if (isSet) {
        cssObj['background-status'] = 'hidden';
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    }
    return cssObj;
  }

  async function showFeedBindModal() {
    if (currentVersion.hasOwnProperty("feeds") && Array.isArray(currentVersion.feeds)) {
      dispatch(setSelectPathModalKind('dynamicText'));
      dispatch(setSelectedTag(item));
      if (item.isFeed) {
        const foundFeed = connectedFeed.find(feed => feed.path === item.value);
        if (foundFeed) {
          dispatch(setSelectedPath(foundFeed));
        }
      } else {
        dispatch(setSelectedPath(null));
      }
      dispatch(toggleSelectPathModal());
    } else {
      dispatch(toggleFeedConnectionModal());
      dispatch(toggleFeedConnectionLoader());
      dispatch(setFeedsPage(1));
      dispatch(setFeedsLoading(false));
      dispatch(setFeedsShowLoader(false));
      dispatch(setFeedsHasMore(true));
      dispatch(setFeedsFirstLoad(false));
      await dispatch(getFeeds());
      dispatch(toggleFeedConnectionLoader());
    }
  }

  async function showTargetUrlModal() {
    dispatch(setSelectedTag(item.tag));
    dispatch(toggleTargetUrlModal());
  }

  function getImagePathFromCreativeObj(nodeObj) {
    let foundImagePath = null;
    const node = Object.keys(nodeObj);
    let k = 0;
    do {
      if (nodeObj[node[k]].name) {
        if (cleanString(nodeObj[node[k]].name) === item.name && nodeObj[node[k]].bgimages) {
          foundImagePath = nodeObj[node[k]].bgimages['1x'].data;
          break;
        }
      }
      k++;
    } while (k < node.length);
    return foundImagePath;
  }

  function isTransparentImage() {
    if (imageType === 'png' || imageType === 'webp') {
      return true;
    } else {
      return false;
    }
  }

  function convertDynamicVideo() {
    let prevDynamicText = [];
    let currentDynamicText = {};
    if (activeDynamicText.isCreative) {
      const foundDynamicText = dynamicText.find(item => item.isCreative && item.creativeId === activeDynamicText.creativeId);
      if (foundDynamicText) {
        prevDynamicText = foundDynamicText;
      }
    } else if (activeDynamicText.isCreative === false) {
      prevDynamicText = dynamicText[0];
    }
    const texts = [];
    prevDynamicText.texts.forEach((textItem, textIdx) => {
      if (textIdx === idx) {
        texts.push({ ...textItem, type: 'video', value: '', poster: '' });
      } else {
        texts.push(textItem);
      }
    });
    const keys = Object.keys(prevDynamicText);
    keys.forEach(dKey => {
      if (dKey !== 'texts') {
        currentDynamicText[dKey] = prevDynamicText[dKey];
      }
    })


    currentDynamicText.texts = texts;
    const updatedDynamicTexts = [];
    dynamicText.forEach((dItem, dIdx) => {
      if (currentDynamicText.isCreative) {
        if (dItem.creativeId === currentDynamicText.creativeId) {
          updatedDynamicTexts.push(currentDynamicText);
        } else {
          updatedDynamicTexts.push(dItem);
        }
      } else {
        if (dIdx === 0) {
          updatedDynamicTexts.push(currentDynamicText);
        } else {
          updatedDynamicTexts.push(dItem);
        }
      }
    });

    if (activeDynamicText.isCreative) {
      dispatch(setDynamicText(updatedDynamicTexts));
      dispatch(setActiveDynamicText(null));
      setTimeout(() => {
        dispatch(setActiveDynamicText(currentDynamicText));
      }, 1);
    } else {
      const newDynamicTextObj = { ...dynamicText[0], texts: texts, isCreative: true, creativeId: selectedCreative._id };
      delete newDynamicTextObj._id;
      delete newDynamicTextObj.id;
      dispatch(setDynamicText([...dynamicText, newDynamicTextObj]));
      dispatch(setActiveDynamicText(null));
      setTimeout(() => {
        dispatch(setActiveDynamicText(newDynamicTextObj));
      }, 1);
    }


    if (scrollableNodeRef.current) {
      setTimeout(() => {
        scrollableNodeRef.current.scrollTop = 0
      }, 2);
    }
  }

  return (
    <div className={isComponentVisible ? 'selected-dynamic-item dynamic-item' : 'dynamic-item'} onMouseOver={highlightImage} onMouseOut={removeHighlight}>
      <div className='d-flex flex-row align-items-center justify-content-between mb-1'>
        <div className={'w-100 text-truncate d-flex align-items-center ' + (!isVisible ? 'dynamic-item-disabled' : '')}>
          <i className='bx bx-image-alt align-bottom fs-15 me-1'></i>
          <span className='w-auto text-truncate me-1' style={{ maxWidth: '100%' }}>{item.name}</span>
          <span className='dynamic-image-size me-2'>{pixelSize}</span>
        </div>
        <div className='d-flex align-items-center gap-1'>
          <button className='btn btn-icon btn-sm btn-soft-dark' onClick={convertDynamicVideo} disabled={!isVisible}>
            <i className='ri-video-line align-bottom fs-15'></i>
          </button>
          <button
            className={'btn btn-icon btn-sm ' + (item.isFeed ? ' btn-info' : ' btn-soft-dark')}
            style={{ position: 'relative', zIndex: '0' }}
            onClick={showFeedBindModal}
            disabled={!isVisible}
          >
            <i className='mdi mdi-rss'></i>
          </button>
          <button
            className={'btn btn-icon btn-sm ' + (item.hasOwnProperty('targetUrl') ? 'btn-primary' : 'btn-soft-dark')}
            style={{ position: 'relative', zIndex: '0' }}
            onClick={showTargetUrlModal}
            disabled={!isVisible}
          >
            <i className='mdi mdi-link'></i>
          </button>
          <div class="form-check form-switch form-switch-right form-switch-sm me-3 d-flex align-items-center">
            <input class="form-check-input code-switcher" type="checkbox" id="input-group-dropdown-showcode" checked={isVisible} onChange={() => toggleBackground(true)} />
          </div>
        </div>
      </div>
      <div className={'w-100 d-flex flex-row flex-nowrap ' + (!isVisible ? 'dynamic-item-disabled' : '')} style={{ height: '100px' }}>
        <div className={'me-2 dynamic-image-container transparent-background'}>
          {defaultImage ?
            <img src={defaultImage} draggable='false' />
            :
            null}
        </div>
        <DropFile handleUpload={async (file) => await loadImage(file)} size='sm' message='Drag & Drop your image or Browse' />
      </div>
    </div>
  )
}

export default DynamicImage
